import init from "./init";
// if (!!window && !window?.setupWebViewJavascriptBridge) {
//     init();
// }
const SYSTEM = {
  ANDROID: "android",
  IOS: "ios",
  PC: "pc",
};

/**
 * getSystem 判断浏览器环境是android还是ios
 * @return {String} android || ios
 */
function getSystem() {
  const userAgent = navigator.userAgent,
    isAndroid = userAgent.includes("platform/popAndroid"),
    isIOS = userAgent.includes("platform/popIos");
  if (isAndroid) {
    return SYSTEM.ANDROID;
  }
  if (isIOS) {
    return SYSTEM.IOS;
  }
}

/**
 * 判断环境是否为app环境
 */
function isPopApp() {
  if (typeof window !== "undefined") {
    const system = getSystem();
    return system === SYSTEM.IOS || system === SYSTEM.ANDROID;
  } else {
    return false;
  }
}

/**
 * 跳转首页TAB
 */
function hybridGoHome() {
  openApp("pop://global.popmart.com/home");
}

/**
 * 跳转星球TAB
 */
function hybridGoPlanet() {
  openApp("pop://global.popmart.com/planet");
}

/**
 * 跳转商品列表页（Collection集合）
 */
function hybridGoCollection(id) {
  openApp(`pop://global.popmart.com/collection?id=${id}`);
}

/**
 * 跳转大盒
 */
function hybridGoBigBox(spuExtId, spuId) {
  openApp(
    `pop://global.popmart.com/bigbox?spuExtId=${spuExtId}&spuId=${spuId}`
  );
}

/**
 * 跳转抽盒列表
 */
function hybridGoBoxList() {
  openApp(`pop://global.popmart.com/boxlist`);
}

/**
 * 跳转本地仓
 */
function hybridGoLocalExpress() {
  const system = getSystem();
  if (system === SYSTEM.ANDROID) {
    openApp("pop://global.popmart.com/local-express");
  } else {
    openApp(`pop://global.popmart.com/flashDelivery`);
  }
}

/**
 * 跳转商品详情页
 */
function hybridGoProduct(id) {
  openApp(`pop://global.popmart.com/product?id=${id}`);
}

/**
 * 跳转用户主页
 */
function hybridGoCustomer(id) {
  openApp(`pop://global.popmart.com/customer/index?gid=${id}`);
}

/**
 * 跳转话题详情页
 */
function hybridGoTopic(id) {
  openApp(`pop://global.popmart.com/topic/detail?topicId=${id}`);
}

/**
 * 跳转我的页面
 */
function hybridGoMe() {
  openApp("pop://global.popmart.com/me");
}

/**
 * 跳转外部链接
 */
function hybridGoExternalLink(URL) {
  openApp(
    `pop://global.popmart.com/url?externalLink=${encodeURIComponent(URL)}`
  );
}

/**
 * 跳转我的奖励
 */
function hybridGoEarnedRewards() {
  openApp("pop://global.popmart.com/earnedRewards");
}

/**
 * 跳转门店购详情
 */
function hybridGoStorePickUp(spuID, storeID) {
  openApp(
    `pop://global.popmart.com/storeProduct?id=${spuID}&storeId=${storeID}`
  );
}

// const isGreaterThan9 = () => {
//   const versionMatch = navigator.userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/);
//   const version = versionMatch ? parseInt(versionMatch[1], 10) : 0;
//   // alert(`versionMatch: ${versionMatch} version: ${version}`);
//   return version >= 9;
// };

const openApp = (link = "pop://global.popmart.com/") => {
  if (isPopApp()) {
    try {
      window.setupWebViewJavascriptBridge((bridge) => {
        bridge.callHandler("openPage", {
          link: link,
        });
      });
    } catch (_err) {}
  } else {
    if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
      const loadDateTime = new Date().getTime();
      if (link) {
        window.location.href = link;
      }
      // if (!isGreaterThan9()) {
      setTimeout(function () {
        //如果没有安装app,便会执行setTimeout跳转下载页
        const timeOutDateTime = new Date().getTime();
        if (timeOutDateTime - loadDateTime < 5000) {
          // router.push("/downLoadApp");
          window.location.href = "https://www.popmart.com/download";
        } else {
          window.close();
        }
      }, 1500);
      // }
    } else if (navigator.userAgent.match(/android/i)) {
      try {
        if (link) {
          window.location.href = link;
        }
        window.setTimeout(function () {
          // router.push("/downLoadApp");
          window.location.href = "https://www.popmart.com/download";
        }, 1500);
      } catch (_e) {}
    }
  }
};

/**
 * 同步doughnuts
 */
const refreshDoughnuts = (data) => {
  try {
    window.setupWebViewJavascriptBridge((bridge) => {
      bridge.callHandler("refreshDoughnuts", {
        doughnuts: data,
      });
    });
  } catch (_err) {}
};

/**
 * cf&poptoken
 */
const refreshDoughnutAndCFToken = (CFToken, doughnuts) => {
  try {
    window.setupWebViewJavascriptBridge((bridge) => {
      bridge.callHandler("refreshDoughnutAndCFToken", {
        CFToken,
        doughnuts,
      });
    });
  } catch (_err) {}
};

/**
 * cf验证失败
 */
const onCloudflareVerifyFailed = () => {
  try {
    window.setupWebViewJavascriptBridge((bridge) => {
      bridge.callHandler("onCloudflareVerifyFailed", {});
    });
  } catch (_err) {}
};

/**
 * cf加载失败
 */
const onCloudflareSDKLoadFailed = () => {
  try {
    window.setupWebViewJavascriptBridge((bridge) => {
      bridge.callHandler("onCloudflareSDKLoadFailed", {});
    });
  } catch (_err) {}
};

/**
 * 弹窗取消
 */
const oncloseAppLoading = () => {
  try {
    window.setupWebViewJavascriptBridge((bridge) => {
      bridge.callHandler("closeAppLoading", {});
    });
  } catch (_err) {}
};

/**
 * app收银台
 */
const goWebCash = ({ orderNo, currency, amount }) => {
  return new Promise((_, reject) => {
    try {
      window.setupWebViewJavascriptBridge((bridge) => {
        bridge.callHandler("webCash", {
          orderNo: orderNo,
          currency: currency,
          amount: amount,
        });
      });
    } catch (_err) {
      reject("go webCash error");
    }
  });
};

/**
 * 下载图片
 */
const saveImage = (url) => {
  const userAgent = navigator.userAgent,
    isAndroid = userAgent.includes("platform/popAndroid");

  return new Promise((resolve, reject) => {
    try {
      window.setupWebViewJavascriptBridge((bridge) => {
        bridge.callHandler("saveImage", { image: url }, (res) => {
          if (isAndroid) {
            resolve(JSON.parse(res));
          } else {
            resolve(res);
          }
        });
      });
    } catch (_err) {
      console.log("bridge.callHandler saveImage failed", _err);
      reject("bridge saveImage failed");
    }
  });
};

/**
 * 获取ios端上用户信息
 */
const getUserInfo = () => {
  const userAgent = navigator.userAgent,
    isAndroid = userAgent.includes("platform/popAndroid");

  return new Promise((resolve, reject) => {
    if (isPopApp()) {
      try {
        window.setupWebViewJavascriptBridge((bridge) => {
          bridge.callHandler("getLoginInfo", {}, (res) => {
            if (isAndroid) {
              resolve(JSON.parse(res));
            } else {
              resolve(res);
            }
          });
        });
      } catch (_err) {
        reject("getUserInfo failed");
      }
    } else {
      reject("not in app");
    }
  });
};

/** 调取客户端登录方法 */
const getAppLogin = (needReLogin = true) => {
  return new Promise((resolve, reject) => {
    if (isPopApp()) {
      try {
        window.setupWebViewJavascriptBridge((bridge) => {
          bridge.callHandler("requestLogin", {}, (res) => {
            const jsonRes = typeof res === "object" ? res : JSON.parse(res);
            if (jsonRes?.code !== 1 && needReLogin) {
              getAppLogin();
            } else if (jsonRes?.code !== 1 && !needReLogin) {
              reject({
                code: 90010,
                msg: "requestLogin failed",
              });
            } else {
              resolve(jsonRes);
            }
          });
        });
      } catch (_error) {
        reject("requestLogin failed");
      }
    } else {
      reject("not in app");
    }
  });
};

/**
 * 获取app版本
 */
const getAppVersion = () => {
  const userAgent = navigator.userAgent,
    isAndroid = userAgent.includes("platform/popAndroid");

  return new Promise((resolve) => {
    try {
      window.setupWebViewJavascriptBridge((bridge) => {
        bridge.callHandler("getAppVersion", {}, (res) => {
          resolve(res);
          if (isAndroid) {
            resolve(JSON.parse(res));
          } else {
            resolve(res);
          }
        });
      });
    } catch (_err) {
      resolve({
        code: 0,
        error: "lower than 4.4.0",
      });
    }
  });
};

export {
  getSystem,
  isPopApp,
  hybridGoHome,
  hybridGoPlanet,
  hybridGoCollection,
  hybridGoBigBox,
  hybridGoBoxList,
  hybridGoLocalExpress,
  hybridGoProduct,
  hybridGoCustomer,
  hybridGoTopic,
  hybridGoMe,
  hybridGoExternalLink,
  init,
  openApp,
  getUserInfo,
  getAppLogin,
  hybridGoEarnedRewards,
  saveImage,
  hybridGoStorePickUp,
  refreshDoughnuts,
  goWebCash,
  getAppVersion,
  refreshDoughnutAndCFToken,
  onCloudflareVerifyFailed,
  onCloudflareSDKLoadFailed,
  oncloseAppLoading,
};
